import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import Lock from '@mui/icons-material/Lock';

const ListItem = ({ item, lowestOrder, pageAuthor, currentUser }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [childrenLength, setChildrenLength] = useState(0);

  useEffect(() => {
    let totalChildren = 0;
    if (item.children) {
      item.children.forEach(child => {
        if (child.isPrivate === 0 || pageAuthor === currentUser) {
          totalChildren++;
        }
      })
    }
    setChildrenLength(totalChildren)
  }, [item.children, pageAuthor, currentUser])
  
  const toggleExpand = () => setIsExpanded(!isExpanded);

  // Render the list item with its title
  return (
    <div>
      {item.type === "folder" && (item.isPrivate === 0 || pageAuthor === currentUser) &&
      <div className="folder-block-item" onClick={toggleExpand}>
        <div  
          style={item.parentId === null && item.order === lowestOrder? {borderTop: `none`} : null}
        >
          {item.title}, ({childrenLength} item{childrenLength !== 1 && "s"})
        </div>
        <div>
          {item.isPrivate === 1 && <Lock id="folders-block-lock"/>}
          {isExpanded? <ExpandLess onClick={toggleExpand}/>:<ExpandMore onClick={toggleExpand}/>}
        </div>
      </div>
      }
      {item.type === "page" && (item.isPrivate === 0 || pageAuthor === currentUser) &&
      <Link className="folder-block-item"  
        to={`/${item.authorId}/page/${item.pageCode}`} 
        style={item.folderId === null && item.order === lowestOrder? {borderTop: `none`} : null}
      >
        {item.title} {item.isPrivate === 1 && <Lock id="folders-block-lock"/>}
      </Link>}
      {/* Check if it's a folder or collection, then render children if expanded */}
      {isExpanded && item.children && item.children.length > 0 && (
        <div>
          {item.children.map((child, index) => (
            <ListItem key={index} item={child} pageAuthor={pageAuthor} currentUser={currentUser} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ListItem;